<script setup>
import { onMounted } from 'vue';

import AgentTable from './overview/AgentTable.vue';
import ReportSectionCard from './ReportSectionCard.vue';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import { useLiveRefresh } from 'dashboard/composables/useLiveRefresh';

const store = useStore();

const uiFlags = useMapGetter('getOverviewUIFlags');
const agentConversationMetric = useMapGetter('getAgentConversationMetric');
const agents = useMapGetter('agents/getAgents');

const fetchData = () => store.dispatch('fetchAgentConversationMetric');

const { startRefetching } = useLiveRefresh(fetchData);

onMounted(() => {
  store.dispatch('agents/get');
  fetchData();
  startRefetching();
});
</script>

<template>
  <ReportSectionCard
    :title="$t('OVERVIEW_REPORTS.AGENT_CONVERSATIONS.HEADER')"
    :description="$t('OVERVIEW_REPORTS.AGENT_CONVERSATIONS.DESCRIPTION')"
    icon="i-hugeicons-user-multiple"
    live
    flush
  >
    <AgentTable
      :agents="agents"
      :agent-metrics="agentConversationMetric"
      :is-loading="uiFlags.isFetchingAgentConversationMetric"
    />
  </ReportSectionCard>
</template>
